module.exports = __webpack_public_path__ + "img/blebox_logo_inverted.1bbc029b.svg";